import {get, post} from './Tools';

const aplicarCorreccion = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}correccion_acumulados/aplicar-correccion`, payload);
  return response;
};

const obtenerHistorial = async (empleado_id, anio, mes) => {
  let url = `${process.env.REACT_APP_SERVER}correccion_acumulados/historial?`;
  if (empleado_id) url += `empleado_id=${empleado_id}&`;
  if (anio) url += `anio=${anio}&`;
  if (mes) url += `mes=${mes}`;
  const response = await get(url);
  return response;
};

const obtenerHistorialDetalle = async (correccion_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}correccion_acumulados/historial-detalle/${correccion_id}`);
  return response;
};

const obtenerAcumulados = async (empleado_id, anio, mes) => {
  const response = await get(`${process.env.REACT_APP_SERVER}correccion_acumulados/acumulados?empleado_id=${empleado_id}&anio=${anio}&mes=${mes}`);
  return response;
};

export { aplicarCorreccion, obtenerHistorial, obtenerHistorialDetalle, obtenerAcumulados };
